// @file Vuex Store for showing Confirmation Dialog (e.g. for deleting padlets)
import { OzConfirmationDialogBoxButtonScheme } from 'library/v4/components/OzConfirmationDialogBox.vue'
import type { DispatchableAction, Wall } from 'types'
import { Module } from 'vuex'

enum ConfirmationDialogLayoutVariant {
  Small = 'Small',
  Large = 'Large',
  Drawer = 'Drawer',
}

interface ConfirmationDialogPayload {
  subject?: null | { wall: Wall }
  layoutVariant?: ConfirmationDialogLayoutVariant
  iconSrc?: string | null
  iconAlt?: string | null
  title?: string
  body?: string
  confirmButtonText?: string
  cancelButtonText?: string
  afterConfirmActions: DispatchableAction[]
  isCodeProtected?: boolean
  buttonScheme: OzConfirmationDialogBoxButtonScheme
  forceFullWidthButtons?: boolean
  xShadow?: boolean
  shouldFadeIn?: boolean
}

interface ConfirmationDialogState extends Required<ConfirmationDialogPayload> {
  isOpen: boolean
}

const blankState = (): ConfirmationDialogState => ({
  isOpen: false,

  layoutVariant: ConfirmationDialogLayoutVariant.Small,
  subject: null,
  iconSrc: null,
  iconAlt: null,
  title: '',
  body: '',
  confirmButtonText: '',
  cancelButtonText: '',
  afterConfirmActions: [],
  isCodeProtected: false,
  buttonScheme: OzConfirmationDialogBoxButtonScheme.Default,
  forceFullWidthButtons: false,
  xShadow: false,
  shouldFadeIn: true,
})

const ConfirmationDialogModule: Module<ConfirmationDialogState, object> = {
  namespaced: true,
  state: blankState,
  mutations: {
    RESET_CONFIRMATION_DIALOG(state): void {
      Object.assign(state, blankState())
    },
    OPEN_CONFIRMATION_DIALOG(state, dialogState: Partial<ConfirmationDialogState>): void {
      Object.assign(state, dialogState)
      state.isOpen = true
    },
  },
  actions: {
    openConfirmationDialog({ commit }, params: ConfirmationDialogPayload): void {
      commit('OPEN_CONFIRMATION_DIALOG', params)
    },
    executeConfirmActions({ dispatch }, actions: DispatchableAction[]): void {
      actions.forEach((actionHash): void => {
        dispatch(actionHash.type, actionHash.payload, { root: true })
      })
    },
    confirm({ commit, dispatch, state }): void {
      dispatch('executeConfirmActions', state.afterConfirmActions)
      commit('RESET_CONFIRMATION_DIALOG')
    },
    cancel({ commit }): void {
      commit('RESET_CONFIRMATION_DIALOG')
    },
    confirmationError({ dispatch }, snackbarPayload): void {
      dispatch('snackbar', snackbarPayload, { root: true })
    },
  },
}

export default ConfirmationDialogModule
export {
  ConfirmationDialogLayoutVariant,
  ConfirmationDialogState,
  ConfirmationDialogPayload,
  OzConfirmationDialogBoxButtonScheme,
}
